export default __webpack_public_path__ + "static/media/project3.d9c078e7.jpg";